'use client';

import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';

import authStore from 'stores/AuthStore';
import Button from '@sympla/sympla-components/Button';
import LoadingSkeleton from './RenderAuth.skeleton';

import * as styles from '../Session.css';

function RenderAuth({ isAuthenticated }: { isAuthenticated: boolean }) {
  const containerLoginRef = useRef(null);
  const [isLoginVisible, setIsLoginVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(isAuthenticated);

  const handleCallback = (data: string) => {
    const component = window.symplaAuthComponent;
    const containerLogin = containerLoginRef.current;
    if (component && containerLogin) {
      if (data === 'forgotPassword') {
        component.renderComponentInElement(containerLogin, 'forgotPassword');
      }
    }
  };

  const renderAuthComponent = (type: 'signIn' | 'signUp' = 'signIn') => {
    const component = window.symplaAuthComponent;
    const containerLogin = containerLoginRef.current;

    if (component && containerLogin) {
      component.renderComponentInElement(containerLogin, type, handleCallback);
    }
  };

  const toggleAuthComponent = () => {
    renderAuthComponent(isLoginVisible ? 'signUp' : 'signIn');
    setIsLoginVisible(!isLoginVisible);
  };

  useEffect(() => {
    setIsAuth(authStore.isAuthenticated);
  }, [authStore.isAuthenticated]);

  useEffect(() => {
    const checkAndRenderAuthComponent = () => {
      if (typeof window.symplaAuthComponent?.renderComponentInElement === 'function') {
        setIsLoading(false);
        renderAuthComponent('signIn');
        return true;
      }
      return false;
    };

    if (!checkAndRenderAuthComponent()) {
      const intervalId = setInterval(() => {
        if (checkAndRenderAuthComponent()) {
          clearInterval(intervalId);
        }
      }, 500);
    }
  }, [isLoading, isAuth]);

  if (isAuth) {
    return null;
  }

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  return (
    <div className={styles.sectionContainerLoginBox}>
      <div>
        <p className={styles.loginBoxDescription}>
          Você precisa estar logado para visualizar seus eventos favoritados
        </p>

        <div ref={containerLoginRef} />

        <span className={styles.loginBoxFooter}>
          {isLoginVisible ? 'Não possui uma conta?' : 'Já possui uma conta?'}
          <Button
            size="medium"
            onClick={toggleAuthComponent}
            variant="text"
          >
            {isLoginVisible ? 'Cadastre-se' : 'Entrar'}
          </Button>
        </span>
      </div>
    </div>
  );
}

export default observer(RenderAuth);
